//--------------------------------------------------------------------------
// <copyright file="FluentPrimaryButton.js" company="Microsoft">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------
import React from 'react'
import { PrimaryButton } from '@fluentui/react';

/// <summary>
/// Wrapper over the primary button from microsoft fluent library.
/// </summary>
const FluentPrimaryButton = ({ text, cssClassName, onClickFunction, isButtonDisabled }) => {
  const styles = {
    root: [
      {
        fontSize: '15px',
        fontFamily: 'Segoe UI',
        fontWeight: 400,
      }
    ]
  };
  return (
    <div>
      <PrimaryButton aria-label={text} disabled={isButtonDisabled} className={cssClassName} text={text} onClick={() => onClickFunction()} styles={{ styles }} />
    </div>
  )
}

export default FluentPrimaryButton
